import {MailTemplate} from "./mailTemplate";

export class Mail {
    public id: string;
    public type: string;
    public to: {
        listType: string,
        listId: string
    };
    public status: string;
    public sentDate: Date;
    public subject: string;
    public body: string;
    public templateId: string;
    public template: MailTemplate;
    public logs: any[];
    public active: boolean;

    constructor(){
        this.to = {
            listType: null,
            listId: null
        };
    }
}



// WEBPACK FOOTER //
// ./src/classes/mail.ts